// iPhone Safari Aggressive Cart Fix
(function () {
  "use strict";

  // Check if we're on iPhone Safari
  const isIPhoneSafari =
    /iPhone/.test(navigator.userAgent) &&
    /Safari/.test(navigator.userAgent) &&
    !/Chrome/.test(navigator.userAgent);

  if (!isIPhoneSafari) {
    return;
  }

  console.log("iPhone Safari detected - applying aggressive cart fix");

  // Validate variant ID
  function validateVariantId(variantId) {
    if (!variantId) return false;

    // Convert to string and remove any whitespace
    const cleanId = String(variantId).trim();

    // Check if it's a valid number
    if (!/^\d+$/.test(cleanId)) {
      console.log("Invalid variant ID format:", variantId);
      return false;
    }

    return cleanId;
  }

  // Force add to cart using multiple methods
  async function forceAddToCart(variantId, quantity = 1) {
    console.log("Force adding to cart:", variantId, quantity);

    // Validate variant ID
    const validVariantId = validateVariantId(variantId);
    if (!validVariantId) {
      console.log("Invalid variant ID, trying to find valid one");

      // Try to find a valid variant ID from the page
      const variantInputs = document.querySelectorAll('input[name="id"]');
      for (const input of variantInputs) {
        const testId = validateVariantId(input.value);
        if (testId) {
          console.log("Found valid variant ID:", testId);
          return await forceAddToCart(testId, quantity);
        }
      }

      console.log("No valid variant ID found");
      return false;
    }

    // Method 1: Direct fetch with JSON
    try {
      console.log("Trying Method 1: JSON request");
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        credentials: "same-origin",
        body: JSON.stringify({
          id: parseInt(validVariantId),
          quantity: parseInt(quantity),
        }),
      });

      console.log("Method 1 response status:", response.status);

      if (response.ok) {
        const data = await response.json();
        console.log("Method 1 success:", data);

        if (data.status) {
          console.log("Method 1 returned error:", data.description);
          throw new Error(data.description);
        }

        await forceUpdateCart();
        return true;
      } else {
        const errorText = await response.text();
        console.log("Method 1 HTTP error:", response.status, errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }
    } catch (error) {
      console.log("Method 1 failed:", error.message);
    }

    // Method 2: Form data approach
    try {
      console.log("Trying Method 2: Form data request");
      const formData = new FormData();
      formData.append("id", validVariantId);
      formData.append("quantity", quantity.toString());

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        credentials: "same-origin",
        body: formData,
      });

      console.log("Method 2 response status:", response.status);

      if (response.ok) {
        const data = await response.json();
        console.log("Method 2 success:", data);

        if (data.status) {
          console.log("Method 2 returned error:", data.description);
          throw new Error(data.description);
        }

        await forceUpdateCart();
        return true;
      } else {
        const errorText = await response.text();
        console.log("Method 2 HTTP error:", response.status, errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }
    } catch (error) {
      console.log("Method 2 failed:", error.message);
    }

    // Method 3: Traditional form submission
    try {
      console.log("Trying Method 3: Traditional form submission");

      // Create a hidden form
      const form = document.createElement("form");
      form.method = "POST";
      form.action = "/cart/add";
      form.style.display = "none";

      const idInput = document.createElement("input");
      idInput.type = "hidden";
      idInput.name = "id";
      idInput.value = validVariantId;

      const quantityInput = document.createElement("input");
      quantityInput.type = "hidden";
      quantityInput.name = "quantity";
      quantityInput.value = quantity.toString();

      form.appendChild(idInput);
      form.appendChild(quantityInput);
      document.body.appendChild(form);

      // Submit the form
      form.submit();

      // Remove the form
      setTimeout(() => {
        if (document.body.contains(form)) {
          document.body.removeChild(form);
        }
      }, 1000);

      console.log("Method 3 executed (form submission)");

      // Wait a bit then check cart
      setTimeout(async () => {
        await forceUpdateCart();
      }, 2000);

      return true;
    } catch (error) {
      console.log("Method 3 failed:", error.message);
    }

    return false;
  }

  // Force update cart and open drawer
  async function forceUpdateCart() {
    console.log("Force updating cart");

    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();

      console.log("Current cart:", cart);

      if (cart.item_count > 0) {
        // Update cart count in header
        const cartCountElements = document.querySelectorAll(
          ".cart-count-bubble, .cart-count"
        );
        cartCountElements.forEach((element) => {
          element.textContent = cart.item_count;
          element.style.display = "block";
        });

        // Force open cart drawer
        await forceOpenCartDrawer(cart);
      }
    } catch (error) {
      console.log("Force update cart failed:", error);
    }
  }

  // Force open cart drawer
  async function forceOpenCartDrawer(cart) {
    console.log("Force opening cart drawer");

    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer) {
      console.log("No cart drawer found");
      return;
    }

    // Force visibility
    cartDrawer.style.visibility = "visible";
    cartDrawer.style.opacity = "1";
    cartDrawer.style.display = "block";
    cartDrawer.classList.add("active");

    // Force inner drawer to slide in
    const drawerInner = cartDrawer.querySelector(".drawer__inner");
    if (drawerInner) {
      drawerInner.style.transform = "translateX(0)";
      drawerInner.style.webkitTransform = "translateX(0)";
      drawerInner.style.visibility = "visible";
      drawerInner.style.opacity = "1";
    }

    // Add body class
    document.body.classList.add("overflow-hidden");

    // Update cart contents
    await updateCartContentsFallback(cart);
  }

  // Fallback cart contents update
  async function updateCartContentsFallback(cart) {
    console.log("Using fallback cart contents update");

    try {
      // Fetch cart sections
      const response = await fetch("/?sections=cart-drawer,cart-icon-bubble");
      const sections = await response.json();

      // Update cart drawer content
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer && sections["cart-drawer"]) {
        const cartContent = cartDrawer.querySelector(".drawer__contents");
        if (cartContent) {
          const temp = document.createElement("div");
          temp.innerHTML = sections["cart-drawer"];
          const newContent = temp.querySelector(".drawer__contents");
          if (newContent) {
            cartContent.innerHTML = newContent.innerHTML;
          }
        }
      }
    } catch (error) {
      console.log("Fallback cart update failed:", error);
    }
  }

  // Override all product forms
  function overrideProductForms() {
    console.log("Overriding product forms");

    const productForms = document.querySelectorAll("product-form");
    productForms.forEach((productForm) => {
      if (productForm.hasAttribute("data-overridden")) {
        return;
      }

      productForm.setAttribute("data-overridden", "true");

      // Override submit handler
      productForm.onSubmitHandler = async function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        console.log("Product form submitted");

        // Get variant ID
        const variantInput = this.querySelector('input[name="id"]');
        if (!variantInput) {
          console.log("No variant input found");
          alert("Product configuration error. Please refresh the page.");
          return;
        }

        const variantId = variantInput.value;
        console.log("Raw variant ID:", variantId);

        // Get quantity
        const quantityInput = this.querySelector('input[name="quantity"]');
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

        // Show loading state
        const submitButton = this.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = "Adding...";
        }

        // Force add to cart
        const success = await forceAddToCart(variantId, quantity);

        // Reset button state
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = "Add to cart";
        }

        if (success) {
          console.log("Product added to cart successfully");
        } else {
          console.log("Failed to add product to cart");
          alert("Failed to add product to cart. Please try again.");
        }
      };
    });
  }

  // Override buy now buttons
  function overrideBuyNowButtons() {
    console.log("Overriding buy now buttons");

    const buyNowButtons = document.querySelectorAll(
      'a.button.button--secondary[href="/products/rvt-digitizer"]'
    );
    buyNowButtons.forEach((button) => {
      if (button.hasAttribute("data-overridden")) {
        return;
      }

      button.setAttribute("data-overridden", "true");
      button.href = "javascript:void(0)";

      button.addEventListener("click", async function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        console.log("Buy now button clicked");

        // Find product form and submit it
        const productForm = document.querySelector("product-form");
        if (productForm) {
          productForm.onSubmitHandler(evt);
        } else {
          // Fallback: try to add default variant
          const variantInput = document.querySelector('input[name="id"]');
          if (variantInput) {
            await forceAddToCart(variantInput.value, 1);
          }
        }
      });
    });
  }

  // Initialize fixes
  function init() {
    console.log("Initializing iPhone Safari cart fixes");

    // Apply fixes immediately
    overrideProductForms();
    overrideBuyNowButtons();

    // Apply fixes again after a delay
    setTimeout(() => {
      overrideProductForms();
      overrideBuyNowButtons();
    }, 1000);

    // Apply fixes on DOM changes
    const observer = new MutationObserver(() => {
      overrideProductForms();
      overrideBuyNowButtons();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  // Start the fix
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
